import { render } from "./NuevoBloqueoView.vue?vue&type=template&id=2c43f847&ts=true"
import script from "./NuevoBloqueoView.vue?vue&type=script&lang=ts"
export * from "./NuevoBloqueoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__